<template>
    <el-dialog
        title="选择公司"
        :visible.sync="visible"
        width="30%"
        :before-close="befclose">
        <div>
            <el-radio-group v-model="company">
                <el-row :gutter="20" v-for="(data,index) in companyList" :key="index" :class="{'background-row-choose':data.label==company}">
                    <el-col :span="24">
                        <el-radio :label="data.label">{{data.companyName}}</el-radio>
                    </el-col>
                </el-row>
            </el-radio-group>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleCancel">取 消</el-button>
            <el-button type="primary" @click="handleConfirm">完 成</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { crmApi } from "@/services";
// const R = require("ramda");
export default {
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        companyList: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            company: {
                type: Object
            }
        };
    },
    watch: {
    },
    methods: {
        handleCancel() {
            this.$emit("handleCancel");
        },
        handleConfirm() {
            console.log(this.company);
            this.$emit("handleConfirm");
        },
        befclose() {
            this.$emit("befclose");
        }
    }
};
</script>
<style lang="scss" scoped>
.el-dialog__wrapper {
    /deep/.el-dialog__header {
        padding: 21px 0px 18px 23px;
        border-bottom: 1px solid #dcdfe5;
    }
    /deep/.el-dialog__title {
        color: #323232;
    }
    /deep/.el-dialog__body {
        padding: 10px 20px;
        .el-radio-group {
            display: block;
            .background-row-choose {
                background: #f5f5f5;
            }
            .el-row {
                padding: 22px 0;
                .el-radio__input.is-checked .el-radio__inner {
                    border-color: #ed2e3d;
                    background: #ed2e3d;
                }
                .el-radio__input.is-checked + .el-radio__label {
                    color: #323232;
                }
                .el-radio__inner {
                    width: 16px;
                    height: 16px;
                }
            }
        }
    }
}
</style>
